import React from 'react'
import styled from 'styled-components'
import { Tabs, Collapse, Typography, Divider, Button } from 'antd'
import { SendOutlined } from '@ant-design/icons'

import qrStores from 'src/assets/images/qr_stores.svg'
import appleStoreImg from 'src/assets/images/download_appstore.avif'
import googlePlayImg from 'src/assets/images/download_googleapp.avif'

const { TabPane } = Tabs
const { Panel } = Collapse
const { Title, Paragraph, Text } = Typography

/* =======================
   STYLED COMPONENTS
======================= */

const PageWrapper = styled.div`
   max-width: 1200px;
   margin: 0 auto;
   padding: 24px 16px;
`

const DownloadTitle = styled.h2`
   text-align: center;
   font-size: 36px;
   font-weight: 700;
   margin-bottom: 12px;

   @media (max-width: 768px) {
      font-size: 26px;
   }
`

const DownloadDesc = styled.p`
   text-align: center;
   font-size: 18px;
   line-height: 1.6;
   margin-bottom: 48px;
   color: #333;

   @media (max-width: 768px) {
      font-size: 15px;
      margin-bottom: 32px;
      padding: 0 12px;
   }
`

const DownloadContainer = styled.div`
   display: flex;
   justify-content: center;
   align-items: center;
   gap: 64px;
   flex-wrap: wrap;

   @media (max-width: 768px) {
      flex-direction: column;
      gap: 32px;
   }
`

const StoreButtons = styled.div`
   display: flex;
   flex-direction: column;
   gap: 24px;
   align-items: center;
`

const StoreImg = styled.img`
   width: 260px;
   max-width: 100%;
   cursor: pointer;

   @media (max-width: 768px) {
      width: 220px;
   }
`

const QrBox = styled.div`
   background: #000;
   padding: 10px;
   border-radius: 20px;
   display: flex;
   flex-direction: column;
   align-items: center;
`

const QrImg = styled.img`
   width: 240px;
   height: 240px;
   background: #fff;
   padding: 12px;
   border-radius: 16px;

   @media (max-width: 768px) {
      width: 200px;
      height: 200px;
   }
`

const QrText = styled.div`
   margin-top: 16px;
   color: #fff;
   font-size: 18px;
   font-weight: 700;
   letter-spacing: 2px;

   @media (max-width: 768px) {
      font-size: 14px;
      letter-spacing: 1px;
   }
`

const StyledTabs = styled(Tabs)`
   .ant-tabs-nav {
      margin-bottom: 16px;
   }
`

const ContactWrapper = styled.div`
   text-align: center;
   margin-bottom: 40px;
`

/* =======================
   COMPONENTS
======================= */

const DownloadAppBlock = () => (
   <>
      <Divider />

      <DownloadTitle>Tải ứng dụng</DownloadTitle>

      <DownloadDesc>
         Bạn hãy dùng điện thoại quét mã QR dưới đây hoặc tìm ứng dụng <strong>Xe ghép Thanh Hóa - Hà Nội</strong> trên
         Google Play và Apple Store
      </DownloadDesc>

      <DownloadContainer>
         <StoreButtons>
            <a
               href="https://apps.apple.com/us/app/xe-gh%C3%A9p-thanh-ho%C3%A1-h%C3%A0-n%E1%BB%99i/id6755186328"
               target="_blank"
               rel="noopener noreferrer"
            >
               <StoreImg src={appleStoreImg} alt="Download on App Store" />
            </a>

            <a
               href="https://play.google.com/store/apps/details?id=com.carpool.thhn"
               target="_blank"
               rel="noopener noreferrer"
            >
               <StoreImg src={googlePlayImg} alt="Get it on Google Play" />
            </a>
         </StoreButtons>

         <QrBox>
            <QrImg src={qrStores} alt="QR Download App" />
            <QrText>SCAN ME</QrText>
         </QrBox>
      </DownloadContainer>
   </>
)

const ContactBlock = () => (
   <ContactWrapper>
      <Title level={2}>Liên hệ với chúng tôi</Title>
      <Paragraph>
         Nếu bạn không tìm thấy câu trả lời trong phần hỗ trợ bên dưới hoặc có thắc mắc, góp ý hay cần phản ánh bất kỳ
         vấn đề nào, vui lòng liên hệ với chúng tôi.
      </Paragraph>

      <Button
         type="primary"
         size="large"
         icon={<SendOutlined />}
         style={{ borderRadius: 20 }}
         onClick={() => {
            window.location.href = 'tel:0922346888'
         }}
      >
         Liên hệ
      </Button>
   </ContactWrapper>
)

/* =======================
   PAGE
======================= */

const SupportPage = () => (
   <PageWrapper>
      {/* ===== LIÊN HỆ ===== */}
      <ContactBlock />

      {/* ===== TIÊU ĐỀ ===== */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
         <Title level={2} style={{ marginBottom: 0 }}>
            Hỗ trợ - Trợ giúp
         </Title>
      </div>

      <Divider />

      <StyledTabs defaultActiveKey="driver">
         {/* ========== TÀI XẾ ========== */}
         <TabPane tab="Tài xế" key="driver">
            <Collapse accordion>
               <Panel header="Mức giá cho phép" key="1">
                  <Paragraph>
                     Giá chuyến xe trên <Text strong>xegheplinhlinh36.com</Text> được xây dựng nhằm chia sẻ chi phí xăng
                     xe, cầu đường và hao mòn phương tiện, không mang tính kinh doanh vận tải.
                  </Paragraph>
               </Panel>

               <Panel header="Đăng chuyến có mất phí không?" key="2">
                  <Paragraph>Không. Việc đăng chuyến trên ứng dụng hoàn toàn miễn phí.</Paragraph>
               </Panel>

               <Panel header="Làm sao để có hành khách đi xe?" key="3">
                  <ul>
                     <li>Đăng chuyến sớm và đầy đủ thông tin</li>
                     <li>Mô tả rõ điểm đón - trả</li>
                     <li>Thường xuyên kiểm tra và xác nhận yêu cầu</li>
                  </ul>
               </Panel>

               <Panel header="Hủy chuyến có mất phí không?" key="4">
                  <Paragraph>Không mất phí, tuy nhiên nên thông báo sớm cho hành khách.</Paragraph>
               </Panel>
            </Collapse>

            <DownloadAppBlock />
         </TabPane>

         {/* ========== HÀNH KHÁCH ========== */}
         <TabPane tab="Hành khách" key="customer">
            <Collapse accordion>
               <Panel header="Đặt xe qua ứng dụng có mất phí không?" key="1">
                  <Paragraph>Không. Hành khách chỉ thanh toán chi phí chuyến đi trực tiếp cho tài xế.</Paragraph>
               </Panel>

               <Panel header="Làm sao biết chuyến đi đã được xác nhận?" key="2">
                  <ul>
                     <li>Chọn chuyến còn chỗ</li>
                     <li>Gửi yêu cầu đặt chuyến</li>
                     <li>Chờ tài xế xác nhận</li>
                  </ul>
               </Panel>

               <Panel header="Hủy chuyến có mất phí không?" key="3">
                  <Paragraph>Không mất phí trước giờ khởi hành.</Paragraph>
               </Panel>

               <Panel header="Có thanh toán trực tiếp trong app không?" key="4">
                  <Paragraph>Hiện tại ứng dụng chưa hỗ trợ thanh toán trực tuyến.</Paragraph>
               </Panel>
            </Collapse>

            <DownloadAppBlock />
         </TabPane>

         {/* ========== CÂU HỎI KHÁC ========== */}
         <TabPane tab="Câu hỏi khác" key="other">
            <Collapse accordion>
               <Panel header="xegheplinhlinh36.com là gì?" key="1">
                  <Paragraph>Nền tảng kết nối tài xế và hành khách tuyến Thanh Hóa - Hà Nội.</Paragraph>
               </Panel>

               <Panel header="Thông tin cá nhân có được bảo mật không?" key="2">
                  <Paragraph>Chúng tôi cam kết bảo mật thông tin người dùng theo quy định pháp luật.</Paragraph>
               </Panel>
            </Collapse>

            <DownloadAppBlock />
         </TabPane>
      </StyledTabs>
   </PageWrapper>
)

export default SupportPage
